var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 10V14.4824L18.3838 16.6162C18.8725 17.105 18.8725 17.895 18.3838 18.3838C18.14 18.6275 17.82 18.75 17.5 18.75C17.18 18.75 16.86 18.6275 16.6162 18.3838L14.1162 15.8838C13.8812 15.6488 13.75 15.3313 13.75 15V10C13.75 9.31 14.3088 8.75 15 8.75C15.6912 8.75 16.25 9.31 16.25 10ZM18.75 8.75C18.75 9.44 19.3088 10 20 10H25C25.6912 10 26.25 9.44 26.25 8.75V3.75C26.25 3.06 25.6912 2.5 25 2.5C24.3088 2.5 23.75 3.06 23.75 3.75V6.16241C21.4375 3.84741 18.3052 2.5 14.9677 2.5C8.0939 2.5 2.5 8.1075 2.5 15C2.5 21.8925 8.0939 27.5 14.9677 27.5C19.7464 27.5 24.0212 24.8374 26.1224 20.5499C26.4262 19.9299 26.1711 19.1813 25.5511 18.8776C24.9311 18.5738 24.1813 18.8301 23.8788 19.4501C22.2 22.8738 18.7864 25 14.9677 25C9.47265 25 5 20.5138 5 15C5 9.48625 9.4714 5 14.9677 5C17.4264 5 19.7525 5.90875 21.5488 7.5H20C19.3088 7.5 18.75 8.06 18.75 8.75Z",
    fill: "url(#paint0_linear_11_194)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_194",
    x1: -4,
    y1: -4.5,
    x2: 14.3752,
    y2: 27.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B2FBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44C0FA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.9748d6599c8e358c633372d6f2f25bef.svg";
export { ForwardRef as ReactComponent };